import { useApiTradeV1SiteMaterialsRetrieveSuspense } from 'api';
import { useParams } from 'react-router-dom';

export const useSiteMaterial = () => {
  const { siteMaterialId } = useParams<{ siteMaterialId: string }>();

  return useApiTradeV1SiteMaterialsRetrieveSuspense(siteMaterialId || '');
};
